export default "__VITE_ASSET__qtfp0Cr5__"